import { login } from '@/api/user'
import { wechatJt } from '@/api/wechat_api'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'
import router from '@/router/index'
import wxLogin from '@/api/user'

const user = {
    state: {
        token: getToken(),
        userInfo: getUserInfo(),
        //name:sessionStorage.getItem("name")
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo
        },

    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            // console.log(userInfo)
            let data = new FormData()
            data.append('code', userInfo.code)
            data.append('state', userInfo.state)
            return new Promise((resolve, reject) => {
                login(data).then(res => {
                    const data = res
                    if (!data.errcode) {
                        setToken(data.token)
                        setUserInfo(data.userinfo)
                        commit('SET_TOKEN', data.token)
                        commit('SET_USERINFO', data.userinfo)
                    }
                    resolve(data)
                }).catch(error => {
                    reject(error)
                });
            })

        },
        GetWxParam({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                wechatJt(userInfo).then(res => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        LogOut({ commit, state }) {
            removeToken()
            removeUserInfo()
            //sessionStorage.removeItem("name")
            wxLogin('wxbca9a1aeb51664cb',location.href.split('#')[0].split('?')[0])
        }


    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js